import React__default, { useContext, createContext } from 'react';
import { u as useIsMobile } from '../theme/MobileThemeProvider/useIsMobile-6efebbf8.js';

const DropdownIsMobileContext = /*#__PURE__*/createContext(false);
const DropdownIsMobileProvider = ({
  mobileFullScreen,
  children
}) => {
  const isMobile = useIsMobile();
  const dropdownIsMobile = mobileFullScreen && isMobile || false;
  return /*#__PURE__*/React__default.createElement(DropdownIsMobileContext.Provider, {
    value: dropdownIsMobile
  }, children);
};
DropdownIsMobileProvider.defaultProps = {
  mobileFullScreen: false
};
const useDropdownIsMobile = () => {
  const isMobile = useContext(DropdownIsMobileContext);
  return isMobile;
};
const DropdownIsMobileConsumer = ({
  children
}) => {
  const isMobile = useDropdownIsMobile();
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, children(isMobile));
};

export { DropdownIsMobileProvider as D, DropdownIsMobileConsumer as a, useDropdownIsMobile as u };
//# sourceMappingURL=DropdownIsMobileContext-c2f1e868.js.map
